import { render, staticRenderFns } from "./busaries.vue?vue&type=template&id=5e08fa67&"
import script from "./busaries.vue?vue&type=script&lang=js&"
export * from "./busaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports